import { Mail, Phone, WhatsApp } from '@mui/icons-material'
import Form from '../Commen/Form'

const ContactModal = () => {
  return (
    <>
      <div className="container mx-0 px-0">
        <div className="row">
          <div className="col-12 mx-0 px-0 text-center mb-3">
            <h2 className="fw-bolder text-center text-danger info-title"
              data-aos="zoom-out"
              data-aos-duration="1000">Let's do great work together.</h2>
            <p className="fw-900 px-2"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200">Send us your query and you will get back to you soon.</p>
            <Form />
          </div>
          {/* <hr /> */}
          {/* <div className="col-12 text-center">
            <p className="fw-900"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="400">Or Let's start speak with our expert.</p>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12 contact my-2">
                <a className="lead contactIcon" href="tel:+7769864038" target="_bluecoder"> <Phone /> Call Now</a>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 contact my-2">
                <a className="lead contactIcon" href="mailto:ashirvadtidake@gmail.com" target="_bluecoder"> <Mail /> Write a Mail </a>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 contact my-2">
                <a className="lead contactIcon" href="https://wa.me/917769864038?text=I'm%20interested%20in%20making%20my%20business%20website" target="_bluecoder"><WhatsApp /> WhatsApp</a>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}

export default ContactModal